import { render, staticRenderFns } from "./ProjectMilestoneList.vue?vue&type=template&id=7fa80a54&"
import script from "./ProjectMilestoneList.vue?vue&type=script&lang=js&"
export * from "./ProjectMilestoneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports